import Bugsnag from '@bugsnag/js';
import { defineBoot } from '@quasar/app-vite/wrappers';
import store from 'src/store';

/**
 * Detects browser features/support.
 */
export default defineBoot(async () => {
  await Promise.all([
    resizeObserverSupport(),
    store().dispatch('env/setBrowserSupport', {
      isTouchOnly: detectTouchOnly(),
      webGl: detectWebGl(),
    }),
  ]);

  store().dispatch('env/detectDeviceSupport');
});

/**
 * Detects if browser/device only supports touch (no mouse pointer).
 */
export function detectTouchOnly() {
  return window.matchMedia('(any-hover: none)').matches;
}

/**
 * Detects WebGL2 support.
 *
 * @returns {boolean}
 */
export function detectWebGl() {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl2') || canvas.getContext('experimental-webgl2');

  const webgl2Supported = gl instanceof WebGL2RenderingContext;

  if (!webgl2Supported) {
    Bugsnag.notify(new Error('WebGL2 not supported'));
  }

  return webgl2Supported;
}

/**
 * Detects if ResizeObserver exists and loads a polyfill if not.
 */
export async function resizeObserverSupport() {
  if (!window.ResizeObserver) {
    const { ResizeObserver } = await import('@juggle/resize-observer');
    window.ResizeObserver = ResizeObserver;
  }
  const patchResizeObserver = (await import('src/services/raf-resize-observer')).default;
  // Replace ResizeObserver with RafResizeObserver
  patchResizeObserver();
}
